import React from 'react'

export const Historial = () => {
  return (
    <div>Historial</div>
  )
}
